import { EventObject } from "../../../../../../util/event/EventObject";
/**
 * SessionTimeOutEvent.ts
 */
export class SessionTimeOutEvent extends EventObject {
}
SessionTimeOutEvent.TIME_OUT = new EventObject("SessionTimeOutEvent.TIME_OUT");
//# sourceMappingURL=SessionTimeOutEvent.js.map